import {
  PageContent,
  AnyAssetApplication,
  useAssetConfig,
  useAssetTranslation,
} from '@mss/mss-component-library';
import React from 'react';
import SettingsForm from '../Shared/SettingsForm';
import { configType } from '../utils/conversions';

function Settings<AssetType extends AnyAssetApplication>() {
  const { t } = useAssetTranslation();
  const { config } = useAssetConfig<AssetType>();
  return (
    <PageContent
      title={t(`Configure ${configType(config.listView.assetType)}`)}
    >
      <SettingsForm />
    </PageContent>
  );
}

export default Settings;
